import React from "react";
import styles from "./chat-header.module.css";
import { DEFAULT_PROFILE_IMAGE } from "../../../../../../constants/common";
import { LeftOutlined, MoreOutlined } from '@ant-design/icons';
import { useChat } from "../../../../../../context/chat-context";
import { useNavigate } from "react-router-dom";
  
const ChatHeader = ({
  name,
  designation = "",
  imgUrl,
  isOnline = false,
  setSelectedChat,
}) => {
  const { isSupportPath } = useChat();
  const navigate = useNavigate();

  return (
    <div className={styles["chat-header-container"]}>
      <div className={styles["chat-user-details"]}>
        <LeftOutlined 
          onClick={() => isSupportPath ? navigate(-1) : setSelectedChat(null)} 
          className={`${styles["back-button"]} ${!isSupportPath && styles["chat-back-btn"]}`}
        />
        <div className={styles["chat-header-profile-wrapper"]}>
          <img 
            src={imgUrl ? imgUrl : DEFAULT_PROFILE_IMAGE}
            height={44}
            width={44}
            className={styles["chat-header-profile"]}
            alt="avatar" 
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = DEFAULT_PROFILE_IMAGE;
            }}
          />
          {!isSupportPath && (
            <span className={`${styles["header-status-dot"]} ${styles[isOnline ? 'online' : 'offline']}`} />
          )}
        </div>
        <div>
          <p className={styles["chat-user-name"]}>{name}</p>
          <p className={styles["chat-user-designation"]}>{designation}</p>
        </div>
      </div>
      <div>
        <MoreOutlined className={styles["chat-more-icon"]} />
      </div>
    </div>
  );
};
export default ChatHeader;
